<div class="border border-light rounded shadow p-3 mt-3" *ngIf="isContinuousServiceSupported">
  <fieldset>
    <legend>
      <h2 class="">Servizio Continuativo</h2>
    </legend>
    <form [formGroup]="continuousServiceForm">
      <div class="row g-3 align-items-end">
        <div class="col-md-4">
          <div class="form-check">
            <input type="checkbox" class="form-check-input" id="continuousJob" formControlName="continuousJob">
            <label class="form-check-label fw-bold" for="continuousJob">Servizio continuativo</label>
          </div>
        </div>
        <div class="col-md-4">
          <label class="form-label fw-bold" for="estimatedLasting">Data di fine</label>
          <input type="date" class="form-control" id="estimatedLasting" formControlName="estimatedLasting">
        </div>
        <div class="col-md-4 d-flex justify-content-end">
          <button type="button" class="btn btn-secondary text-white" [disabled]="!hasContinuousServiceChanges"
            (click)="saveContinuousService()">Salva</button>
        </div>
      </div>
      <p class="fw-light fs-6 mt-3 mb-0" *ngIf="continuousServiceForm.get('continuousJob')?.value">
        <i class="bi bi-info-circle me-2"></i>Il giorno 25 di ogni mese, se la data corrente è precedente alla Data
        di fine, l'ultimo evento Utilizzo in stato "Da pagare" o "Pagato" verrà duplicato automaticamente per il
        mese successivo in stato "Da validare".
      </p>
    </form>
  </fieldset>
</div>

<div class="border border-light rounded shadow p-3 mt-3" *ngIf="isLongevity">
  <fieldset>
    <legend>
      <h2 class="text-center fw-bold">Registro</h2>
    </legend>
    <!-- <p class="mb-3">
      <i class="bi bi-info-circle me-2"></i>Per la Longevity non ci sono eventi da registrare: qui sotto trovi i
      test compilati per questa richiesta e le relative risposte.
    </p> -->
    <app-longevity-request-assessments [requestId]="request.id"></app-longevity-request-assessments>
  </fieldset>
</div>

<div class="border border-light rounded shadow p-3 mt-3" *ngIf="isCaregiverConsult">
  <fieldset>
    <legend>
      <h2 class="text-center fw-bold">Registro</h2>
    </legend>
    <app-request-chat
      [requestId]="request.id"
      [initialMessages]="chatMessages"
      [status]="request.operationalInfo.status"
      (statusChanged)="onChatStatusChanged($event)"
    ></app-request-chat>
  </fieldset>
</div>

<div class="border border-light rounded shadow p-3 mt-3" *ngIf="!isLongevity && !isCaregiverConsult">
  <fieldset>
    <legend>
      <h2 class="text-center fw-bold">Registro</h2>
    </legend>
    <div>
      <div class="my-4 d-flex gap-2 align-items-center">
        <p class="mb-0">Per creare un evento <span class="fw-bold">clicca qui:</span></p>
        <button class="btn btn-secondary text-white" (click)="openDepForm()">
          <span>
            <i *ngIf="!showNewDepForm" class="bi bi-bag-plus-fill me-2"></i>
            <i *ngIf="showNewDepForm" class="bi bi bi-bag-x-fill me-2"></i>
          </span>{{showNewDepForm ? 'Chiudi' : 'Aggiungi'}}
        </button>
      </div>
    </div>
    <hr>
    <div>
      <app-request-record-form *ngIf="showNewDepForm" (onUpdate)="updateList()"
        [businessLine]="request.requestPersonalInfo.requestCategory" [isNew]="true" [caregiverDTO]="caregiverDTO"
        [requestId]="request.id" [hoursComputed]="hoursComputed"></app-request-record-form>
    </div>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title><b>Eventi</b></mat-panel-title>
      </mat-expansion-panel-header>
      <app-round-b2b-table [caregiverDTO]="caregiverDTO" (refreshList)="updateList()" [hoursComputed]="hoursComputed"
        [rounds]="(records$ | async)!"></app-round-b2b-table>
    </mat-expansion-panel>
  </fieldset>
</div>

<div class="border border-light rounded shadow p-3 mt-3">
  <fieldset>
    <legend>
      <h2 class="">Stato della richiesta</h2>
    </legend>
    <div>
      <app-request-state-handler [request]="request"></app-request-state-handler>
    </div>
  </fieldset>
</div>
